<div class="wrapper">
    <div class="alert alert-dismissible custom-alert-success" *ngIf="mobileChanged">
        <button
            type="button"
            (click)="closeModel($event)"
            class="close close-modified"
            data-dismiss="alert">
            &times;
        </button>
        <div class="login-error-text">
            <div class="error-icon"><img src="assets/images/success.png" /></div>
            <div class="login-error-message">Mobile Number Updated Successfully</div>
        </div>
    </div>
    <app-success-model
        message="{{ createdMessage }}"
        [display]="userCreated"
        (event)="closeModel($event)"></app-success-model>
    <app-navigation></app-navigation>
    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
        <app-content-transition></app-content-transition>
        <app-header
            buttonText="Add New User"
            location="Search Users"
            [showHeaderButton]="true"></app-header>
        <app-links></app-links>
        <section class="add-section">
            <form [formGroup]="form">
                <div class="row">
                    <div class="col-md-12 section-heading">User Search</div>
                </div>
                <div class="row pb-3">
                    <div class="col-md-6">
                        <label class="form-label">
                            SEARCH BY USERNAME, ENTERPRISE OR MOBILE NUMBER
                        </label>
                        <div class="input-icons">
                            <i class="fa fa-search icon" aria-hidden="true"></i>
                            <input
                                class="form-input"
                                type="text"
                                placeholder="eg. Name Surname or 0723117955"
                                formControlName="text" />
                            <a *ngIf="form.get('text').value.length > 0" (click)="clearText()">
                                <img src="assets/images/close-x-purple.png" />
                            </a>
                        </div>
                    </div>
                    <div class="col-md-6 search-controls">
                        <label class="form-label"></label>
                        <div>
                            <button class="search-button" (click)="submit()">Search</button>
                            <a class="advanced-search" (click)="toggleOption()">
                                <u>
                                    <img class="mr-2" src="assets/images/dropdown.png" />
                                    ADVANCED SEARCH
                                </u>
                            </a>
                            <a class="clear-filters" (click)="clearFilters()">
                                <u>CLEAR FILTERS</u>
                            </a>
                        </div>
                    </div>
                </div>
                <hr *ngIf="showOptions" />
                <div class="search-form width-100" *ngIf="showOptions">
                    <div class="row">
                        <div class="col-md-3">
                            <label class="form-label">BUSINESS NAME</label>
                            <div>
                                <input
                                    class="form-input"
                                    type="text"
                                    placeholder="eg. Business Name"
                                    formControlName="businessName" />
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label">ACCOUNT TYPE</label>
                            <div>
                                <app-select-box
                                    placeholderValue="Select Type"
                                    [form]="form"
                                    value="role"
                                    [invalidForm]="invalidForm"
                                    [dropDown]="accountTypeDropdown">
                                </app-select-box>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label">ACCOUNT STATUS</label>
                            <div>
                                <app-select-box
                                    placeholderValue="Select Status"
                                    [form]="form"
                                    value="status"
                                    [invalidForm]="invalidForm"
                                    [dropDown]="statusDropdown">
                                </app-select-box>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label">REFERRED BY</label>
                            <div>
                                <input
                                    class="form-input"
                                    type="text"
                                    placeholder="Name or Business Name"
                                    formControlName="referredBy" />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3">
                            <label class="form-label">ID TYPE</label>
                            <div>
                                <app-select-box
                                    placeholderValue="Select Status"
                                    [form]="form"
                                    value="idType"
                                    [invalidForm]="invalidForm"
                                    [dropDown]="idTypeDropdown">
                                </app-select-box>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label">ID NUMBER</label>
                            <div>
                                <input
                                    class="form-input"
                                    type="text"
                                    placeholder="eg. 8906020107083"
                                    formControlName="idNumber" />
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label">PROVINCES</label>
                            <ng-select
                                [items]="provinceList"
                                bindLabel="province"
                                placeholder="Select Province"
                                [multiple]="false"
                                formControlName="provinceId"
                                bindValue="id">
                            </ng-select>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label">SUBURB</label>
                            <div>
                                <input
                                    class="form-input"
                                    type="text"
                                    placeholder="Suburb"
                                    formControlName="suburb" />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <mat-form-field appearance="fill">
                                <mat-label>Enter a date range</mat-label>
                                <mat-date-range-input
                                    [formGroup]="form"
                                    [rangePicker]="picker"
                                    appearance="fill">
                                    <input
                                        class="mat-datepicker-input"
                                        matStartDate
                                        formControlName="fromDate"
                                        placeholder="Start date" />
                                    <input
                                        class="mat-datepicker-input"
                                        matEndDate
                                        formControlName="toDate"
                                        placeholder="End date" />
                                </mat-date-range-input>
                                <mat-hint>YYYY/MM/DD/ – YYYY/MM/DD</mat-hint>
                                <mat-datepicker-toggle
                                    matIconSuffix
                                    [for]="picker"></mat-datepicker-toggle>
                                <mat-date-range-picker #picker></mat-date-range-picker>

                                <!-- Validation errors -->
                                <!-- Only show one general error for fromDate  -->
                                @if (form.get('fromDate')?.touched) {
                                    <mat-error
                                        *ngIf="
                                            form.get('fromDate')?.hasError('matStartDateInvalid') ||
                                            form.get('fromDate')?.hasError('matDatepickerParse')
                                        ">
                                        Invalid start date
                                    </mat-error>
                                }

                                <!-- Only show one general error for toDate -->
                                @if (form.get('toDate')?.touched) {
                                    <mat-error
                                        *ngIf="
                                            form.get('toDate')?.hasError('matEndDateInvalid') ||
                                            form.get('toDate')?.hasError('matDatepickerParse')
                                        ">
                                        Invalid end date
                                    </mat-error>
                                }

                                <!-- Show range logic error -->
                                @if (form.touched && form.hasError('invalidDateRange')) {
                                    <mat-error>End date must be after start date</mat-error>
                                }
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="searched-items">
                    <div *ngIf="searchItems.length > 0">
                        <div *ngFor="let item of searchItems" class="search-item-value">
                            {{ item | humanize }}
                            <a (click)="removeSearchItem(item)">
                                <img src="assets/images/close-x-white.png" />
                            </a>
                        </div>
                    </div>
                </div>
            </form>
        </section>

        <section *ngIf="search">
            <div class="row mb-3" *ngIf="userList.length > 0">
                <div class="col-md-6">
                    <a (click)="downLoadExcel()" class="download-transaction">
                        <u>DOWNLOAD USERS</u>
                    </a>
                </div>
            </div>
            <div class="search-result-header">
                Search Results: {{ userList.length }} of {{ pagination.total }}
                <div class="status-description-search">
                    <div class="circle-left circle-red"></div>
                    <span class="status-description-text">Disabled</span>
                </div>
                <div class="status-description-search">
                    <div class="circle-left circle-yellow"></div>
                    <span class="status-description-text">Pending Review</span>
                </div>
                <div class="status-description-search">
                    <div class="circle-left circle-orange"></div>
                    <span class="status-description-text">Pending Kyc</span>
                </div>
                <div class="status-description-search">
                    <div class="circle-left circle-green"></div>
                    <span class="status-description-text">Active</span>
                </div>
            </div>
            <hr />
            <div class="container-fluid tab-pane custom-table">
                <br />
                <table class="tableData user-table-fix">
                    <thead>
                        <tr>
                            <th class="col-name">
                                <app-filter-arrow
                                    filter="name"
                                    title="NAME & SURNAME"
                                    (filterValue)="receiveFilter($event)">
                                </app-filter-arrow>
                            </th>
                            <th class="col-business">
                                <app-filter-arrow
                                    filter="businessName"
                                    title="BUSINESS NAME"
                                    (filterValue)="receiveFilter($event)">
                                </app-filter-arrow>
                            </th>
                            <th class="col-mobile">
                                <app-filter-arrow
                                    filter="mobileNumber"
                                    title="MOBILE NUMBER"
                                    (filterValue)="receiveFilter($event)">
                                </app-filter-arrow>
                            </th>
                            <th class="col-email">
                                <app-filter-arrow
                                    filter="email"
                                    title="EMAIL"
                                    (filterValue)="receiveFilter($event)">
                                </app-filter-arrow>
                            </th>
                            <th class="col-accounts">
                                <app-filter-arrow
                                    filter="role"
                                    title="ACCOUNTS"
                                    (filterValue)="receiveFilter($event)">
                                </app-filter-arrow>
                            </th>
                            <th class="col-wallet">
                                <app-filter-arrow
                                    filter="walletBalance"
                                    title="WALLET BALANCE"
                                    (filterValue)="receiveFilter($event)">
                                </app-filter-arrow>
                            </th>
                            <th class="col-actions">
                                <app-filter-arrow title="ACTIONS"> </app-filter-arrow>
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr class="tablebox" *ngFor="let user of userList">
                            <td class="col-name">
                                <img
                                    alt="Profile"
                                    class="table-user-img"
                                    src="{{
                                        user.profilePicture || 'assets/images/placeholder.png'
                                    }}" />
                                <a (click)="commonUtil.navigate('profile', user)">
                                    <strong>
                                        <u>
                                            <span>{{ user.firstName + ' ' + user.lastName }}</span>
                                        </u>
                                    </strong>
                                </a>
                            </td>

                            <td class="col-business">{{ user.businessName }}</td>

                            <td class="col-mobile">{{ user.mobileNumber }}</td>

                            <td class="col-email">
                                <a href="mailto:{{ user.email }}">
                                    {{ user.email }}
                                </a>
                            </td>

                            <td class="col-accounts">
                                <app-account-status
                                    type="user"
                                    [accounts]="user.accounts"
                                    [status]="user.status"
                                    [businessStatus]="user.businessStatus"
                                    [agentStatus]="user.agentStatus"
                                    [enterpriseStatus]="user.enterpriseStatus"
                                    [staffStatus]="user.staffStatus">
                                </app-account-status>
                            </td>

                            <td class="col-wallet">
                                <div
                                    class="wallet-value"
                                    [ngClass]="{
                                        'wallet-value--warning':
                                            user.belowWarningThreshold &&
                                            !user.belowCutoffThreshold,
                                        'wallet-value--alert': user.belowCutoffThreshold,
                                    }">
                                    <i
                                        *ngIf="
                                            user.belowWarningThreshold || user.belowCutoffThreshold
                                        "
                                        class="fa fa-exclamation-triangle wallet-value__icon">
                                    </i>

                                    <span class="wallet-value__amount">
                                        {{ user.walletBalance | currencyFormat }}
                                    </span>
                                </div>
                            </td>

                            <td class="col-actions">
                                <app-last-child [user]="user"> </app-last-child>
                            </td>
                        </tr>
                    </tbody>

                    <tfoot *ngIf="pagination.showPagination()">
                        <tr>
                            <td>
                                Rows per page:
                                <span
                                    ><b>{{ pagination.length }}</b></span
                                >
                                <app-page-length-dropdown (emitLength)="changeLength($event)">
                                </app-page-length-dropdown>
                            </td>
                            <td>
                                <app-page-navigation
                                    pageNumber="{{ pagination.getPageNo() }}"
                                    totalPages="{{ pagination.getTotalPages() }}"
                                    (changePage)="changePage($event)">
                                </app-page-navigation>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </section>
    </div>
    <div class="control-sidebar-bg"></div>
</div>
